<template>
  <div class="common-breadcrumb-box">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item
        v-for="(item, index) in breadcrumbList"
        :key="index"
        :title="item.name"
        @click.native="breadcrumbClick(item)">
        <div
          class="common-breadcrumb-box-icon text-center-c"
          v-if="index <= 0">
          <icon-svg
            v-if="
              item.name !== '模型管理' &&
              item.name !== '模型组管理' &&
              !item?.isElement
            "
            icon-class="ic-ico_folder1"
            size="14"
            class="icon" />
          <icon-svg
            v-else-if="item?.isElement"
            icon-class="ic-goujiankuguanli"
            size="14"
            class="icon" />
          <img
            v-else
            class="common-breadcrumb-box-icon-img"
            :src="
              require(`@/assets/img/icon-mode${
                item.name === '模型管理' ? '1' : '2'
              }.png`)
            "
            alt="" />
        </div>
        <span
          class="breadcrumb-text"
          :title="item.name"
          :class="index > 0 ? 'sec-menu' : ''">
          {{ item.name }}
        </span>
      </el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>
export default {
  props: {
    breadcrumbList: Array,
    breadcrumbClick: Function
  },
  methods: {
    onClick(data) {
      if (this.breadcrumbList.length === 1) return
      this.breadcrumbClick(data)
    }
  },
  // mounted() {
  //   console.log(this.breadcrumbList, 'list')
  // }
}
</script>

<style lang="less" scoped>
.common-breadcrumb-box {
  width: 100%;
  // height: 32px;
  // padding: 16px 16px 0 16px;

  :deep(.el-breadcrumb) {
    display: flex;
    align-items: center;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
    // height: 24px;
    .sec-menu {
      margin-left: 0;
    }

    .common-breadcrumb-box-icon {
      .svg-icon {
        color: var(--base-primary-bgColor);
      }
    }
  }

  &-icon {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background-color: var(--base-bg-light-color24);

    &-img {
      width: 20px;
      height: 20px;
    }
  }

  :deep(.el-breadcrumb__item) {
    display: flex;
    align-items: center;

    .el-breadcrumb__inner {
      padding-right: 0;
    }

    .el-breadcrumb__separator {
      line-height: 1 !important;
      margin: 0;
      margin-top: 3px !important;
    }
  }

  :deep(.el-breadcrumb__inner) {
    display: flex !important;
    align-items: center;
    justify-content: center;
    border: none !important;
    padding-left: 0 !important;

    .breadcrumb-text {
      font-size: 18px;
      font-weight: 500;
      color: var(--page-bread-text-color);
      margin-left: 10px;
      padding: 2px 6px;
      max-width: 230px;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .sec-menu {
      margin-left: 0;
    }
  }

  .icon {
    width: 16px;
    height: 16px;
  }
}
</style>
